import React from 'react';
import { observer } from 'mobx-react';
import { navigate } from 'js/services/Network';

import { url } from 'js/services/Network';
import analytics from 'js/services/Analytics';

import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';

import AppContent from 'js/components/AppContent';
import PageComponent from 'js/components/pages/PageComponent';
import Constraint from 'js/components/Constraint';
import LoginSignupDialog from 'js/components/common/LoginSignupDialog';

@observer
export default class SignupPage extends PageComponent {
  pageName = 'SignupPage';

  redirect = () => navigate(url('home-page'));

  pageEvent = () => {
    //AppState.isOnLandingPage ? analytics.page('LP_viewed sign up page') : analytics.page('Signup');

    if (AppUser.isLoggedIn) {
      this.redirect();
    }
  };

  renderPage() {
    return (
      <AppContent padded>
        <Constraint>
          <LoginSignupDialog
            showForm="signup"
            afterLogin={this.redirect}
            loginTitle="Log in to your account"
            signupTitle="Create an account"
            signupText="to start using the safest way to buy and sell on any marketplace."
            padded
            termsAndConditions
          />
        </Constraint>
      </AppContent>
    );
  }
}
